import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "components__rec-date-field" }
const _hoisted_2 = { key: 0 }

import parseISO from "date-fns/parseISO";
 import isValid from "date-fns/isValid";
 import format from "date-fns/format";

 import { recProps } from "../../mixins/rec-component";
 
 import SimpleDatepicker from "vue/applications/frontend/components/simple-datepicker.vue"
 
 
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-date-field',
  props: {...recProps()},
  setup(__props) {

 

 const formatISODate = (strDate: string) => {
   if (!strDate) return "";
   const date = parseISO(strDate);
   return isValid(date) ? format(date, "dd.MM.yyyy") : "";
 }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.description.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.description.label) + ": " + _toDisplayString(formatISODate(_ctx.description.ivalue)), 1))
      : (_openBlock(), _createBlock(SimpleDatepicker, {
          key: 1,
          name: _ctx.description.name,
          modelValue: _ctx.description.ivalue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description.ivalue) = $event)),
          small: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.description.label), 1)
          ]),
          _: 1
        }, 8, ["name", "modelValue"]))
  ]))
}
}

})